import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

    Swiper.use([Navigation,Autoplay]);

    const LogoSliderSelector = ".swiper.mySwiper";

    const EventSliderSelector = ".swiper.eventSwiper";

    const ShowcaseSliderSelector = ".swiper.showcaseSwiper";

    //Swiper resolves a selector string against the whole document, so a slider whose
    //component has no arrows of its own binds to another component's buttons - and then
    //stamps its own disabled state on them. Resolve the arrows inside the owning
    //component instead, and fall back to no navigation when it has none.
    function navigationFor(slider, componentSelector) {
        const component = slider.closest(componentSelector);
        return {
            nextEl: component ? component.querySelector(".swiper-button-next") : null,
            prevEl: component ? component.querySelector(".swiper-button-prev") : null,
        };
    }

    function init() {
        const logoSliderElements = document.querySelectorAll(LogoSliderSelector);
        const EventsSliderElements = document.querySelectorAll(EventSliderSelector);
        const showcaseSliderElements = document.querySelectorAll(ShowcaseSliderSelector);

        logoSliderElements.forEach(slider => {
            new Swiper(slider, {
                autoplay:{
                    delay:3000
                },
                slidesPerView: 1,
                loop:true,
                navigation: navigationFor(slider, ".sponsors"),
            });
        });

        EventsSliderElements.forEach(slider => {
            new Swiper(slider, {
                spaceBetween: 15,
                slidesPerView: "1.65",
                centeredSlides: false,
                navigation: navigationFor(slider, ".cards, .events-section"),

                breakpoints: {
                    830: {
                        spaceBetween: 45,
                        slidesPerView: 3,
                    },
                    768: {
                        spaceBetween: 60,
                        slidesPerView: 2,
                    },
                  },
                  on: {
                      slideChangeTransitionEnd: (swiper) => {
                          swiper.update();
                          swiper.el.querySelectorAll(".swiper-slide > a").forEach(slide => {
                              slide.setAttribute("tabindex", "-1");
                          });
  
                          const activeSlide = swiper.el.querySelector(".swiper-slide-active > a");
                          if (activeSlide != null) {
                              activeSlide.setAttribute("tabindex", "0");
                          }
                      }
                  },
                
            });
        });

        showcaseSliderElements.forEach(slider => {
            new Swiper(slider, {
                spaceBetween: 20,
                slidesPerView: 1.8,
                centeredSlides: false,
                watchOverflow: true,
                //The track bleeds past the right gutter on mobile via a negative margin.
                //Reading that margin back keeps the end of the slider inside the content
                //width, without duplicating the CSS breakpoint in JS - Swiper re-evaluates
                //this on every resize.
                slidesOffsetAfter: function () {
                    var bleed = parseFloat(getComputedStyle(this.el).marginRight);
                    return bleed < 0 ? Math.abs(bleed) : 0;
                },
                navigation: navigationFor(slider, ".showcase-slider"),

                breakpoints: {
                    481: {
                        spaceBetween: 24,
                        slidesPerView: 2.2,
                    },
                    667: {
                        spaceBetween: 30,
                        slidesPerView: 3,
                    },
                    993: {
                        spaceBetween: 33,
                        slidesPerView: 4,
                    },
                },
            });
        });
}

init();
